import { lazy } from 'react';
import { wrapLazyNavigatorScreen } from '../../../../../functions/navigation/utils/wrapNavigatorScreen';
import type { ShareOrderPageProps } from './components/ShareOrderPageContentWrapper';

const ShareOrderPageContentWrapper = lazy(
  () => import('./components/ShareOrderPageContentWrapper'),
);

export const ShareOrderPage = wrapLazyNavigatorScreen(
  (props: ShareOrderPageProps) => {
    return <ShareOrderPageContentWrapper {...props} />;
  },
  {
    headerShown: false,
  },
);
